import { render, staticRenderFns } from "./User.vue?vue&type=template&id=0b589f60&"
import script from "./User.ts?vue&type=script&lang=ts&"
export * from "./User.ts?vue&type=script&lang=ts&"
import style0 from "./User.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports